async function initPO(){
    // console.log('initPO')
    let currentProduct = await getCurrentProduct();
    if( !currentProduct ) return;
    // console.log('currentProduct',currentProduct)
    let data_backorder_products_el = document.querySelector('[data-preorder-products]');
    let backorderProducts;
    if( data_backorder_products_el ){
        backorderProducts = data_backorder_products_el.getAttribute('data-preorder-products').split(',');
        // console.log('-_-_-_--__---__----__-- backorderProducts',backorderProducts)
    }
    if( backorderProducts.includes(currentProduct) ){
        // console.log('currentProductIsBackordered')
        let option_group__label = document.querySelector('input[name="colors"][checked]').closest('.product-form__input').querySelector('.form__label');
        if( !option_group__label ) return;
        setPreorderBubble(option_group__label);
    }else{
        return;
    }

    const mutationCallbackPO = async (mutationsList) => {
        let data_attribute = "href"
        for (const mutation of mutationsList) {
            if (
            mutation.type !== "attributes" ||
            mutation.attributeName !== "href"
            ) {
            return
            }
            let new_value = mutation.target.getAttribute("href");
            if ( new_value && new_value != null ) {
                let product = await getCurrentProduct();

                let option_group__label = document.querySelector('input[name="colors"][checked]').closest('.product-form__input').querySelector('.form__label');

                if( backorderProducts.includes(new_value) ){
                    setPreorderBubble(option_group__label);
                }else{
                    resetPreorderBubbles();
                }
            }else{
            }
        }
    }
    
    const observerPO = new MutationObserver(mutationCallbackPO)

    function addObserverIfDesiredNodeAvailablePO() {
        var composeBox = document.querySelector('a.product__title');
        if(!composeBox) {
            //The node we need does not exist yet.
            //Wait 500ms and try again
            window.setTimeout(addObserverIfDesiredNodeAvailablePO,500);
            return;
        }
        // var config = {childList: true};
        observerPO.observe(composeBox, { attributes: true })
    }
    addObserverIfDesiredNodeAvailablePO();
}

function resetPreorderBubbles(){
    let backOrderBubbles = document.querySelectorAll('.backorder-bubble');
    if( backOrderBubbles ) {
        backOrderBubbles.forEach(el => {
            el.parentNode.removeChild(el);
        });
    }
    let productAccordions = document.querySelector('.product-accordions');
    if( productAccordions) productAccordions.classList.remove('show-backorder');
    // removeNotifyButton();
    // if( document.getElementById('backorder-settings') ) document.getElementById('backorder-settings').classList.add('hide');
}

async function getCurrentProduct(){
    let productDisplaySection = document.querySelector('.product__info-wrapper');
    if( !productDisplaySection ) return;
    // console.log('productDisplaySection',productDisplaySection)
    let productHandleElement = productDisplaySection.querySelector('.product__title a');
    if( !productHandleElement ) return;
    // console.log('productHandleElement',productHandleElement)
    productHandle = productHandleElement.getAttribute('href');
    productHandle = productHandle.replace('/products/','');
    // console.log('productHandle',productHandle);
    return productHandle;
}

function setPreorderBubble( container ){
    // console.log('sbb',container)
    resetPreorderBubbles();
    const backorderEl = document.createElement("div");
    backorderEl.innerText = "Pre-order";
    backorderEl.classList.add('backorder-bubble');
    container.append(backorderEl);

    // let productAccordions = document.querySelector('.product-accordions');
    // if( productAccordions ) productAccordions.classList.add('show-backorder');

    // addNotifyButton();
    // if(document.getElementById('backorder-settings')) document.getElementById('backorder-settings').classList.remove('hide');
}

var desktopQueryPO,mobileQueryPO;
if( !desktopQueryPO) {
    desktopQueryPO = window.matchMedia("(min-width: 768px)");
}
if( !mobileQueryPO) {
    var mobileQueryPO = window.matchMedia("(max-width: 767px)");
}

async function handleDeviceChangeDesktopPO(e) {
    if (e.matches) {
        await initPO();
    }
}
async function handleDeviceChangeMobilePO(e,size) {
    if (e.matches) {
        await initPO();
    }
}

// Listen for any screen width changes
desktopQueryPO.addEventListener("change", handleDeviceChangeDesktopPO);
mobileQueryPO.addEventListener("change", handleDeviceChangeMobilePO);

window.addEventListener('load', async function() {
    await initPO();
});